import React, { useState, useEffect } from 'react';
import { Document, pdfjs } from 'react-pdf';

import styles from 'css_modules/File.module.css';

// Loads PDF worker from CDN to avoid ejecting. Change this after (if) ejecting the app.
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const File = ({ file, onLoadSuccess, children }) => {
  const [skip, setSkip] = useState(false);
  const url = file ? process.env.REACT_APP_DOMAIN + file : null;

  useEffect(() => {
    setSkip(false); 
  }, [file]);

  const placeholderText = (
    <p className={styles.placeholderText}>
      {file ? 'Soubor není dostupný' : 'Náhled'}
    </p>
  );

  if (skip) {
    return (
      <p className={styles.placeholderText}>
        PDF soubor je chráněn heslem.
      </p>
    );
  }

  return (
    <Document
      file={url}
      onLoadSuccess={onLoadSuccess}
      loading={''}
      noData={placeholderText}
      externalLinkTarget="_blank"
      className={styles.textAnnotation}
      onPassword={(callback, reason) => {
        const pwd = prompt(
          'PDF soubor je chráněn heslem. Zadejte heslo nebo klikněte na Storno pro přeskočení:'
        );
        if (pwd) {
          callback(pwd);
        } else {
          setSkip(true);
        }
      }}
    >
      {children}
    </Document>
  );
};
